import { Component, OnInit } from '@angular/core';
import { MainserviceService } from './../mainservice.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-mall-shops',
  templateUrl: './mall-shops.component.html',
  styleUrls: ['./mall-shops.component.scss']
})
export class MallShopsComponent implements OnInit {

  shopFilter:any = { name: ''}
  p: number = 1; 

  shops:any;

  constructor(private mainServ: MainserviceService,
              private router:Router
  ) { }

  ngOnInit() {
    this.mainServ.getShops().subscribe(data => {
      this.shops = data
  });
  }

}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/mall-shops/mall-shops.component.ts